module.exports = __webpack_public_path__ + "img/04-3-1技术能力.915ec211.png";